import { bannerList, videoList } from '../../api/banner'
import { homeProductList } from '../../api/home'
import { walletTotal } from "../../api/balance";
import { bulletinList } from "../../api/article";

// initial state
const state = {
  wallet: null,
  bulletin: null,
  banners: null,
  video: null,
  hotProducts: null,
  recentlyProducts: null,
  goodProducts: null,
}

// mutations
const mutations = {
  saveHomeWallet(state, items) {
    state.wallet = items
  },
  saveHomeBulletin(state, items) {
    state.bulletin = items
  },
  saveHomeBanners(state, items) {
    state.banners = items
  },
  saveHomeVideo(state, items) {
    state.video = items
  },
  saveHomeProducts(state, data) {
    state.hotProducts = data.hot_products;
    state.recentlyProducts = data.recently_products;
    state.goodProducts = data.good_products;
  }
}

// actions
const actions = {
  fetchHomeWallet({commit, state}) {
    return new Promise((resolve, reject) => {
      walletTotal().then(
        (response) => {
          if (response && response.data) {
            commit('saveHomeWallet', response.data)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeBulletin({commit, state}) {
    return new Promise((resolve, reject) => {
      bulletinList().then(
        (response) => {
          if (response && response.articles) {
            commit('saveHomeBulletin', response.articles)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeBanner({commit, state}, params) {
    return new Promise((resolve, reject) => {
      bannerList(params.name).then(
        (response) => {
          if (response && response.banners) {
            commit('saveHomeBanners', response.banners)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeVideo({commit, state}, params) {
    return new Promise((resolve, reject) => {
      videoList(params.name).then(
        (response) => {
          if (response && response.video) {
            commit('saveHomeVideo', response.video)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeProduct({commit, state}, params) {
    return new Promise((resolve, reject) => {
      homeProductList(params.name).then(
        (response) => {
          if (response) {
            commit('saveHomeProducts', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js